import React, { Component } from 'react';
import { Container, Header, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Push, push } from 'connected-react-router';
import { EUserLevels, IProject, IUser } from '@relab/alstom-ptw-shared';

import { ProjectCloneModal } from './ProjectCloneModal';
import { ProjectDeleteModal } from './ProjectDeleteModal';
import { ProjectEditModal } from './ProjectEditModal';
import { projectAction } from '../../redux/actions';
import { appState } from '../../redux/selectors';
import { RootState } from '../../redux/types';
import { TranslationComponent } from '../TranslationComponent';

interface ProjectsListComponentProps {
  projects: IProject[];
  projectAction: typeof projectAction;
  user: IUser;
  push: Push;
}

interface ProjectsListComponentState {
  column: string;
  sortedProjects: IProject[];
  direction: 'descending' | 'ascending';
}

class PProjectsListComponent extends Component<ProjectsListComponentProps> {
  state: ProjectsListComponentState = {
    column: 'name',
    sortedProjects: this.props.projects,
    direction: 'ascending',
  };

  componentDidUpdate(prevProps: Readonly<ProjectsListComponentProps>) {
    if (this.props.projects !== prevProps.projects) {
      this.setState({
        sortedProjects: this.props.projects,
      });
    }
  }

  handleSort = (clickedColumn: string) => () => {
    const { projects } = this.props;
    const { column, sortedProjects, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        sortedProjects: projects.sort((a: any, b: any) => (a[clickedColumn] > b[clickedColumn] ? -1 : 1)),
        direction: 'ascending',
      });

      return;
    }

    this.setState({
      sortedProjects: sortedProjects.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    });
  };

  handleSelectProject = (projectId: string) => {
    this.props.projectAction(projectId);
    this.props.push(`/projects/${projectId}`);
  };

  _optionallyRenderButtons = (project: IProject) => {
    const { user } = this.props;

    return user.userLevel === EUserLevels.Admin ? (
      <React.Fragment>
        <ProjectCloneModal project={project} />
        <ProjectEditModal project={project} />
        <ProjectDeleteModal project={project} />
      </React.Fragment>
    ) : null;
  };

  render() {
    const { column, direction, sortedProjects } = this.state;

    return (
      <Container>
        <Header as="h2">
          <TranslationComponent stringKey={'Project list ({{length}})'} values={{ length: sortedProjects.length }} />
        </Header>

        <Table sortable celled fixed>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                <TranslationComponent stringKey={'Name'} />
              </Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedProjects.map((project) => (
              <Table.Row key={project._id}>
                <Table.Cell className="cursor-pointer" onClick={() => this.handleSelectProject(project._id)}>
                  {project.name}
                </Table.Cell>
                <Table.Cell textAlign="right">{this._optionallyRenderButtons(project)}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Container>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
});

export const ProjectsListComponent = connect(mapStateToProps, { push, projectAction })(PProjectsListComponent);
